<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="60%"
      hide-overlay
      scrollable
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar dark color="primary lighten-1" tile>
          <v-toolbar-title>
            Sobre o Sistema Busca
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="fecharModal">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <span class="font-weight-bold"><p>Consulta Processual</p></span>
              <div class="text-justify">
                Trata-se de uma pesquisa textual que permite pesquisar as
                principais peças processuais utilizadas no Sistema de Protocolo
                e Acompanhamento processual eletrônico – e-tcdf. A pesquisa pode
                ser feita por campo livre (Termo) e pode ser filtrada pelos
                tipos documentais disponíveis (relatório/voto, informação,
                parecer, decisão, acórdão, ata de sessão e jurisprudência
                selecionada), pelo ano de cadastro do documento e ser ordenada
                por relevância (mais relevantes, mais antigos ou mais recentes).
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <span class="font-weight-bold"
                ><p>Sobre o Sistema de Jurisprudência - Forseti</p></span
              >
              <div class="text-justify">
                O Sistema de Jurisprudência foi desenvolvido para
                disponibilizar, de forma acessível e rápida, as decisões
                designadas para relato oral, proferidas pelo plenário do TCDF a
                partir de 2019. Decisões anteriores a 2019 podem ser capturadas
                e inseridas no sistema em função de sua relevância. A pesquisa
                no sistema de jurisprudência varia conforme a base de dados
                pesquisada, mas de modo geral, abrange o texto integral das
                decisões e dos seus respectivos votos condutores, além de
                informações essenciais como o Conselheiro Relator, o ano e o
                número da decisão, como exemplo, na pesquisa mais geral.
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <div class="text-justify">
                Como se trata de uma base selecionada, pode ser que a informação
                desejada não esteja disponível no sistema jurisprudencial. Nesse
                caso, é possível realizar busca na base processual do sistema,
                que abrange um rol maior de decisões, inclusive decisões mais
                antigas. Além disso, é possível pesquisar outros tipos de
                documentos (informação, parecer, acórdão, etc), além da Decisão
                e do seu voto condutor
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <span class="font-weight-bold"
                ><p>Bases de dados de Jurisprudência</p></span
              >
              <div class="text-justify">
                O Tribunal disponibiliza quatro bases de dados de pesquisa de
                jurisprudência:
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <ul>
                <li>
                  <p><b>Todas as bases</b></p>
                </li>
              </ul>
              <div class="text-justify">
                Nesse módulo é possível pesquisar todas as decisões capturadas
                pelo sistema de jurisprudência, ou seja, decisões designadas
                para relato oral nas sessões ordinárias, independentemente de
                terem sido escolhidas para a base de jurisprudência selecionada
                ou inteiro teor. Em breve, essa pesquisa também possibilitará a
                busca na nova base de súmulas e boletins que foi criada
                recentemente. A pesquisa pode ser feita por campo livre (Termo)
                e pode ser filtrada pelo ano de cadastro do documento e ser
                ordenada por relevância (mais relevantes, mais antigos ou mais
                recentes).
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <ul>
                <li>
                  <p><b>Inteiro Teor</b></p>
                </li>
              </ul>
              <div class="text-justify">
                Nesse módulo, é possível pesquisar todas as decisões capturadas
                pelo sistema, ou seja, decisões designadas para relato oral nas
                sessões ordinárias, independentemente de terem sido escolhidas
                para a base de jurisprudência selecionada. A pesquisa pode ser
                feita por campo livre (Pesquisa em todos os campos), número da
                decisão, ano ou relator
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <ul>
                <li>
                  <p><b>Jurisprudência selecionada</b></p>
                </li>
              </ul>
              <div class="text-justify">
                Essa pesquisa é composta por decisões que foram selecionadas por
                possuírem uma ou mais tese(s) técnico-jurídica(s) que a(s)
                embasou(aram). Essas teses são selecionadas segundo critérios de
                reiteração, relevância, controvérsia ou ineditismo. As decisões
                selecionadas para compor essa base recebem metadados adicionais
                adicionais que são inseridos melhorar a identificação e
                recuperação da(s) tese(s) técnico-jurídica(s) tratada.
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <div class="text-justify">
                A pesquisa pode ser feita por campo livre (Pesquisa em todos os
                campos), número da decisão, ano ou relator. Adicionalmente, é
                possível pesquisar por:
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <div class="text-justify">
                <ul class="lista-info-busca" style="list-style-type: none;">
                  <li>
                    <b
                      ><v-icon>mdi-check</v-icon>Classificação
                      temática: Processual; Pessoal; Licitações e Contratos;
                      Contas; e Finanças Públicas;
                    </b>
                  </li>
                  <li>
                    <b
                      ><v-icon>mdi-check</v-icon>Paradigmáticas: Em sede de
                      Consulta; e Estudos especiais;</b
                    >
                  </li>
                  <li>
                    <b><v-icon>mdi-check</v-icon>Palavras-chave</b>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <div class="text-justify">
                Adicionalmente, o sistema permite a busca por referências
                legislativas que subsidiaram a fundamentação da tomada de
                decisão. A pesquisa permite, inclusive, pesquisar por um
                dispositivo específico de uma norma.
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <ul>
                <li>
                  <p><b>Súmulas</b></p>
                </li>
              </ul>
              <div class="text-justify">
                O quarto e último módulo de pesquisa de jurisprudência é
                destinado às súmulas aprovadas pelo Plenário do TCDF.
                Atualmente, ao clicar nesta opção, a página redireciona para o
                Sistema Integrado de Normas Jurídicas - SINJ-DF, onde todas as
                súmulas do Tribunal estão disponibilizadas. No entanto, está em
                construção o módulo próprio para o sistema de jurisprudência,
                que irá permitir, dessa forma, uma pesquisa abrangente de
                jurisprudência em um único módulo. Essa pesquisa também irá ser
                apresentada quando se optar pela pesquisa em todas as bases.
              </div>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="auto" class="mx-2">
              <div class="text-justify">
                <img src="../../src/assets/dicasSobreBusca.png" alt="" />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    abrirModal() {
      this.dialog = true;
    },
    fecharModal() {
      this.dialog = false;
    }
  },
  mounted() {
    this.abrirModal();
  }
};
</script>
